import React, { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import interactions from '~/components/page/Automation/v2/state/interactions';
import { Container } from '../../styles';
import EdgeLabelWrapper from '../components/EdgeLabelWrapper';

const text = {
  chooseLeaf: 'Verbind vanaf hier',
};

type Props = {
  midX: number;
  midY: number;
  edgeKey: string;
  testId: string;
  onInsertAction: () => void;
};

/**
 * The container that is shown when the user is choosing a path to connect
 */
const ChooseEdgeLabel: React.FCC<Props> = ({
  midX,
  midY,
  edgeKey,
  testId,
  onInsertAction,
}) => {
  const setCurrentInteraction = useSetRecoilState(interactions);

  const handleMouseEnter = useCallback(() => {
    setCurrentInteraction(prev => {
      if (prev?.type !== 'copyAction') return prev;

      return {
        ...prev,
        copyHoverPreview: {
          ...prev.copyHoverPreview,
          from: { x: midX, y: midY, edgeKey },
        },
      };
    });
  }, [setCurrentInteraction, midX, midY, edgeKey]);

  const handleMouseLeave = useCallback(() => {
    setCurrentInteraction(prev => {
      if (prev?.type !== 'copyAction') return prev;
      if (prev.copyHoverPreview.from?.edgeKey !== edgeKey) return prev;

      return {
        ...prev,
        copyHoverPreview: {
          ...prev.copyHoverPreview,
          from: null,
        },
      };
    });
  }, [setCurrentInteraction, edgeKey]);

  return (
    <EdgeLabelWrapper midX={midX} midY={midY} interactive>
      <Container
        $variant="choose"
        $interactive
        onClick={onInsertAction}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-testid={testId}
      >
        {text.chooseLeaf}
      </Container>
    </EdgeLabelWrapper>
  );
};

export default ChooseEdgeLabel;
